import React from "react";
import { Crown } from "lucide-react";

/**
 * ProBadge — single source of truth for the "Producer-only" perk pill.
 *
 * Two variants:
 *   • `unlocked` (default false): dim amber pill — used on locked controls
 *     for non-Producers to signal "upgrade to access".
 *   • `unlocked={true}`: bright gold pill — used on perks the current user
 *     already has, so the pill reads as "you own this", not "barrier".
 *
 * Used by:
 *   • RecorderPublishFormFields (iter-75) — 9-min duration button corner.
 *   • ProfileTab (iter-76) — Sponsor Link 3 & 4 labels.
 *
 * If the tier branding ever renames (e.g. "Producer" → "Creator"),
 * change the `label` default here and every call site updates.
 */
export const ProBadge = ({
  unlocked = false,
  label = "Pro",
  className = "",
  testId,
}) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-bold uppercase tracking-wide border ${
      unlocked
        ? "bg-amber-500/90 border-amber-300 text-amber-950"
        : "bg-amber-900/80 border-amber-500/60 text-amber-200"
    } ${className}`}
  >
    <Crown className="h-2.5 w-2.5" /> {label}
  </span>
);

export default ProBadge;
